import { menuselect_solution } from "@/constant/menuselect";

let str = "业务概述";
export const config = {
  title: "卫生经济分析与监管",
  headerInfo:
    "卫生经济运行分析与监管云平台涵盖财务管理、预算运行、成本分析、固定资产、人力资源、药耗运行、价格执行、绩效考评的分析与监管子模块，通过对区域医疗机构的资源管理、经济管理、综合管理以及决策分析系统平台建设， 实现各级卫健委实时、动态、连续、综合的监管，促进区域卫生健康事业高质量发展。",
  headerImg: require("@/assets/images/medical_group_sanitation/Rectangle19header.svg"),
  activeSubTitle: str,
  navList: [
    {
      name: "卫生经济分析与监管",
      children: menuselect_solution(),
    },
    {
      name: "业务概述",
      desc: "在高质量发展意见指引下，建立全行业、全流程、综合性、多手段的区域医疗卫生领域综合监管体系，实现医疗卫生行业综合监管法治化、规范化、常态化。加强医疗服务质量、安全、医疗卫生机构运行监管，健全区域医疗卫生领域全面预算 管理、成本管理、财务报告、信息公开以及内部和第三方审计机制。 从业务和场景入手，为满足卫生健康行政主管部门的运营管理与监管的诉求，提出“卫生经济运行分析与监管云平台”解决方案，帮助和促进医疗卫生事业的高质量健康发展，同时结合云计算、大数据、智能 AI 等新技术，不断促进医疗服务水平的提高，更好地维护广大群众的健康权益。",
      tabList: [{}],
      [str]: [
        {
          title: "",
          desc: "卫生经济运行分析与监管云平台涵盖财务管理、预算运行、成本分析、固定资产、人力资源、药耗运行、价格执行、绩效考评的分析与监管子模块，通过对区域医疗机构的资源管理、经济管理、综合管理以及决策分析系统平台建设， 实现各级卫健委实时、动态、连续、综合的监管，促进区域卫生健康事业高质量发展。",
          img: require("@/assets/images/medical_group_sanitation/Frame 935.svg"),
        },
       /*  {
          title: "价值亮点",
          desc: " ",
          img: require("@/assets/images/medical_group_sanitation/Group 1137.svg"),
        }, */
      ],
    },
    {
      name: "价值亮点",
      desc: "",
      tabList: [{}],
      [str]: [
        {
          title: " ",
          desc: " ",
          img: require("@/assets/images/medical_group_sanitation/Group 1137.svg"),
        },
      ],
    },
  ],
};
